import { memo, useMemo, useRef, useState } from 'react'
import _get from 'lodash/get';
import { FooterMenu, IFooterMenuLinkProps } from './footer.types';
import ChevronDown from '../icons/chevron-down';

const FooterMenuLink: React.FC<IFooterMenuLinkProps> = ({
  title,
  menu = []
}) =>  {
  const menuRef = useRef<HTMLUListElement | null>(null);
  const [isShowMenu, setIsShowMenu] = useState(false);
  
  const menuHeight = useMemo(() => (
    (menuRef?.current?.getBoundingClientRect().height || 0) + 56 + 20
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [menuRef?.current]);

  const onClickExpandButton = () => setIsShowMenu((prevState: boolean) => !prevState);

  return (
    <div
        className='w-full md:w-fit md:ml-20 border-b border-[#BABECE]
          md:border-b-0 transition-all duration-300 overflow-hidden h-14 md:h-full'
        style={isShowMenu ? { height: menuHeight } : {}}>
      <h3 className='text-black opacity-60 uppercase font-medium mt-4
        md:mt-0 mb-4 md:mb-6 flex justify-between items-center'>
        {title}
        <button
          className={`block md:hidden transition duration-300 ${isShowMenu ? '-rotate-180' : 'rotate-0'}`}
          onClick={onClickExpandButton}>
          <ChevronDown />
        </button>
      </h3>
      <ul ref={menuRef} className='block'>
        {
          menu.map((item: FooterMenu, index: number) => (
            <li key={index} className='flex items-center mb-6'>
              <a
                href={_get(item, 'url', '')}
                className='text-black font-inter text-14'
                {..._get(item, 'isNewTab', '') ? { target: '_blank', rel: 'noreferrer' } : {}}
              >
                {_get(item, 'name', '')}
              </a>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default memo(FooterMenuLink);
